var exports = {
  "B": "copyLinkSection__4J9Qfi",
  "j": "spacesSuggestionsList__LMEGz5",
};

module.exports = exports;
